var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 173,
    viewBox: "0 0 130 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9967 52.9232C66.2304 52.9232 76.9583 42.1952 76.9583 28.9616C76.9583 15.728 66.2304 5 52.9967 5C39.7631 5 29.0352 15.728 29.0352 28.9616C29.0352 42.1952 39.7631 52.9232 52.9967 52.9232Z",
    stroke: "#3F4D61",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3915 67.3008H43.3149C34.8325 67.3008 27.4044 72.8599 24.9603 80.9589L14.7048 115.224H5.12012",
    stroke: "#3F4D61",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6198 120.016V167.939H29.0352",
    stroke: "#3F4D61",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.374 120.016V167.939H76.9587",
    stroke: "#3F4D61",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1279 75.5484C98.9554 70.1331 104.946 66.5868 111.607 67.4494C119.275 68.4078 124.882 75.3088 124.882 83.0244C124.882 91.363 121.575 99.3662 115.681 105.261L96.1279 124.813L76.5753 105.261C70.6807 99.3662 67.374 91.363 67.374 83.0244C67.374 74.8775 73.604 67.7848 81.751 67.3535C87.981 67.0181 93.4921 70.4206 96.1279 75.5484Z",
    stroke: "#3F4D61",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.0eb33599cbdd420115ef4e0dbd5e6956.svg";
export { ForwardRef as ReactComponent };